import { render, staticRenderFns } from "./InputMethodEditCheckBox.vue?vue&type=template&id=6fe8cec4&scoped=true&"
import script from "./InputMethodEditCheckBox.vue?vue&type=script&lang=ts&"
export * from "./InputMethodEditCheckBox.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fe8cec4",
  null
  
)

export default component.exports